export default "__VITE_ASSET__6jKiYfxS__"